module.exports = __webpack_public_path__ + "static/step_2_2-8c7f4bbc0232baf26f243b7e6621a2ae.svg";